'use client';
import { useTheme, useCSS } from '@s7/styles';
import { isArray, isFunction } from '@s7/utils';

var extractSX = function(theme, sx) {
    return isFunction(sx) ? sx(theme) : sx;
};
var useSX = function(sx, className) {
    var theme = useTheme();
    var _useCSS = useCSS(), css = _useCSS.css, cx = _useCSS.cx;
    if (isArray(sx)) {
        return cx(className, sx.map(function(partial) {
            return css(extractSX(theme, partial));
        }));
    }
    return cx(className, css(extractSX(theme, sx)));
};

export { extractSX, useSX };
